import ImageOne from "../images/house-1.jpg";
import ImageTwo from "../images/house-2.jpg";
import ImageThree from "../images/house-3.jpg";
import ImageFour from "../images/house-4.jpg";
import ImageFive from "../images/slide-1.jpg";
import ImageSix from "../images/slide-2.jpg";
import ImageSeven from "../images/slide-3.jpg";

export const SliderData = [
  {
    title: "Luxury Villa in Bali, Indonesia",
    price: "$4,280,000",
    path: "/homes",
    label: "View Home",
    image: ImageOne,
    alt: "House",
  },
  {
    title: "House in San Jose, Costa Rica",
    price: "$2,860,000",
    path: "/homes",
    label: "View Home",
    image: ImageTwo,
    alt: "House",
  },
  {
    title: "House in Calabasas, California",
    price: "$8,420,000",
    path: "/homes",
    label: "View Home",
    image: ImageThree,
    alt: "House",
  },
  {
    title: "House in Houston, Texas",
    price: "$6,660,000",
    path: "/homes",
    label: "View Home",
    image: ImageFour,
    alt: "House",
  },
];

export const SliderDataTwo = [
  {
    title: "House in Las Vegas, Nevada",
    price: "$8,980,000",
    path: "/homes",
    label: "View Home",
    image: ImageFive,
    alt: "House",
  },
  {
    title: "House in Houston, Texas",
    price: "$3,460,000",
    path: "/homes",
    label: "View Home",
    image: ImageSix,
    alt: "House",
  },
  {
    title: "House in Alajuela, Costa Rica",
    price: "$5,420,000",
    path: "/homes",
    label: "View Home",
    image: ImageSeven,
    alt: "House",
  },
];
